import type { M3UChannel } from "../adapters/static/m3u";

export interface LibraryGridProps {
  channels: M3UChannel[];
  onSelect: (channel: M3UChannel) => void;
}

export function LibraryGrid({ channels, onSelect }: LibraryGridProps) {
  if (channels.length === 0) {
    return <p style={{ padding: 24 }}>No channels found.</p>;
  }
  return (
    <div style={{
      display: "grid",
      gridTemplateColumns: "repeat(auto-fill, minmax(160px, 1fr))",
      gap: 12,
      padding: 16,
    }}>
      {channels.map((ch, i) => (
        <button
          key={`${ch.url}-${i}`}
          onClick={() => onSelect(ch)}
          style={{
            background: "#222",
            border: "1px solid #444",
            padding: 12,
            color: "#fff",
            cursor: "pointer",
            textAlign: "left",
          }}
        >
          {ch.logo && <img src={ch.logo} alt="" style={{ width: "100%", height: 80, objectFit: "contain" }} />}
          <div style={{ marginTop: 8, fontSize: 14, fontWeight: 500 }}>{ch.name}</div>
          <div style={{ marginTop: 4, fontSize: 11, color: "#888" }}>{ch.group}</div>
        </button>
      ))}
    </div>
  );
}
